<article class="catalogSeo" *ngIf="content" [ngClass]="{'catalogSeo--searchResult': searchStore?.searchValue}">
  <ng-container *ngIf="seoContentsTitle">
    <h1 *ngIf="searchStore?.searchValue; else catalogSeoContent" class="catalogSeo__title">
      {{ seoContentsTitle }}
    </h1>
    <ng-template #catalogSeoContent
      ><div class="catalogSeo__title">{{ seoContentsTitle }}</div></ng-template
    >
  </ng-container>

  <div #catalogSeo__description class="catalogSeo__description" [innerHtml]="content.body"></div>
</article>
